<template>
  <div class="chart">
    <v-layout class="chart-tool" style="margin-top: 30px;">
      <v-flex v-if="editMode" row>
        <v-spacer></v-spacer>
        <!--<v-btn flat icon dark @click="$emit('edit-chart', chartId)">
          <v-icon small>build</v-icon>
        </v-btn>-->
        <!--<v-btn flat icon dark @click="deleteChart">-->
          <!--<v-icon small>remove_circle_outline</v-icon>-->
        <!--</v-btn>-->
      </v-flex>
    </v-layout>
    <v-chart
      ref="options"
      @init="initChart"
      :init-Options="initOptions"
      :options="options"
      :autoresize="true"
      :style="{height:height, width:width}"
      >
    </v-chart>
  </div>
</template>

<script>
import ECharts from 'vue-echarts/components/ECharts'
import axios from 'axios'
import echarts from 'echarts'

export default {
  name: 'singleValue',
  components: {
    'v-chart': ECharts
  },
  data () {
    return {
      chart: null,
      x: [],
      y: [],
      key: '*',
      filter: '',
      initOptions: {
        renderer: 'canvas'
      },
      options: {},
      volume: [],
      labels: [],
      useGB: '',
      useMB: '',
      unitMB: 'MB',
      unitGB: 'GB',
      unit: '',
      output: '',
      message: '',
      tcca: true,
      gb: true,
      bytePerEvent: 0,
      index: ''
    }
  },
  props: {
    func: {
      type: String
    },
    className: {
      type: String,
      default: 'chart'
    },
    user_index: {
      type: String
    },
    user_inst: {
      type: String
    },
    username: {
      type: String
    },
    startTime: {
      type: [String, Number]
    },
    endTime: {
      type: [String, Number]
    },
    field: {
      type: String
    },
    fieldsum: {
      type: String,
      default: ''
    },
    stores: {
      type: Array
    },
    valid: {
      type: Boolean
    },
    chartId: {
      type: String
    },
    chartName: {
      type: String,
      default: 'Untitle'
    },
    width: {
      type: [String, Number],
      default: '100%'
    },
    height: {
      type: [String, Number],
      default: '100%'
    },
    lic: {
      type: Number
    },
    editMode: {
      type: Boolean,
      default: false
    },
    index_now: {
      type: String
    },
    reloadchart: {
      type: Boolean,
      default: false
    }
  },
  async created () {
    if (!this.user_index) {
      this.user_index = this.index_now
    }
    this.index = this.user_index
  },
  async mounted () {
    await this.initChart()
    await this.beforeload()
  },
  methods: {
    async initChart () {
      switch (this.func) {
        case 'storedDataSize':
          this.storedDataSize()
          break
        case 'availableDisk':
          this.availableDisk()
          break
        case 'numOfType':
          this.numOfType()
          break
        case 'estRetention':
          this.estRetention()
          break
      }
    },
    beforeload () {
      this.$emit('loadChart', 'load', 'x-single')
    },
    async storedDataSize () {
      this.$refs.options.showLoading({
        color: '#4ea397',
        maskColor: 'transparent',
        textColor: '#ccc'
      })
      let response = await axios.post(apiUrl + '/api/query/dataVolume', {
        start: this.startTime,
        end: this.endTime,
        instance: this.user_inst,
        index: this.user_index,
        field: this.field,
        fieldsum: this.fieldsum
      })
      if (response.data) {
        this.bytePerEvent = response.data.map(a => {
          return a['pri.store.size'] / a['docs.count']
        })
        this.labels = response.data.map(a => {
          return a.index
        })
        this.volome = response.data.map(a => {
          return a['pri.store.size']
        })
        let byte = this.volome.reduce(function (a, b) { return parseInt(a) + parseInt(b) }, 0)
        this.unit = this.unitGB
        let retention = await axios.post(apiUrl + '/api/query/retention', {
          instance: this.user_inst,
          // index: this.user_index,
          index: this.index,
          stores: [],
          start: 'now-150d',
          end: 'now',
          interval: '1d'
        })
        let usageBytePerDay = byte / retention.data
        this.useGB = (usageBytePerDay / 1024 / 1024 / 1024).toFixed(2) // ใช้ไปกี่ GB แล้ว
        this.useMB = (usageBytePerDay / 1024 / 1024).toFixed(2)
        if (this.useGB < 1) {
          this.output = this.useMB
          this.unit = this.unitMB
        } else {
          this.output = this.useGB
          this.unit = this.unitGB
        }
        let gaugeData = []
        let gaugeObj = {}
        let avgGB = ((usageBytePerDay / (this.lic * 1073741824)) * 100).toFixed(2)
        // console.log('avgGB', avgGB)
        // gaugeObj['value'] = this.output
        let format = `\n${this.output}\n${this.unit}/Days`
        gaugeObj['value'] = avgGB
        gaugeObj['name'] = ''
        gaugeData.push(gaugeObj)
        this.$refs.options.hideLoading()
        this.options = {
          title: {
            show: true,
            text: this.chartName,
            textStyle: {
              color: '#ccc',
              fontFamily: 'Avenir, Helvetica, Arial, sans-serif'
            }
          },
          tooltip: {
            // formatter: '{a} <br/>{b} : {c}%'
            formatter: function (params) {
              let rez = '<p>' + avgGB + '%' + '</p>'
              // console.log(params); //quite useful for debug
              return rez
            }
          },
          // toolbox: {
          //   feature: {
          //     saveAsImage: {
          //       title: 'save as image'
          //     }
          //   }
          // },
          series: [{
            name: 'Usage Per Day',
            type: 'gauge',
            center: ['50%', '65%'],
            startAngle: 180,
            endAngle: 0,
            min: 0,
            max: 100,
            radius: '85%',
            splitLine: {
              show: false
            },
            axisLine: {
              lineStyle: {
                color: [
                  [
                    1, new echarts.graphic.LinearGradient(
                      0, 0, 1, 0, [{
                          offset: 0,
                          color: '#5c53de'
                        },
                        {
                          offset: 1,
                          color: '#18c8ff'
                        }
                      ]
                    )
                  ],
                  [
                    1, '#413e54'
                  ]
                ],
                width: 20,
                opacity: 1
              }
            },
            axisTick: {
              show: false
            },
            detail: {
              // formatter:'{value} %',
              // formatter: '{value} ' + this.unit + '/Days',
              formatter: function (params) {
                let rez = format
                return rez
              },
              textStyle: {
                color: 'white',
                fontFamily: 'Avenir, Helvetica, Arial, sans-serif',
                fontSize: 22
              }
            },
            data: gaugeData,
            axisLabel: {
              show: false
            },
            title: {
              textStyle: {
                color: '#ccc'
              }
            },
            itemStyle: {
              color: 'auto'
            }
          }]
        }
      } else {
        this.$refs.options.hideLoading()
        this.options = {
          title: {
            show: true,
            text: this.chartName,
            textStyle: {
              color: '#ccc',
              fontFamily: 'Avenir, Helvetica, Arial, sans-serif'
            }
          },
          backgroundColor: 'transparent',
          graphic: {
            type: 'text',
            left: 'center',
            top: 'middle',
            style: {
              text: 'No data',
              font: 'bolder 16px Avenir, Helvetica, Arial, sans-serif',
              fill: '#ccc'
            }
          },
          series: []
        }
      }
    },
    async availableDisk () {
      this.message = 'Available Disk'
      let response = await axios.post(apiUrl + '/api/query/dataVolume', {
        instance: this.user_inst,
        index: this.user_index
      })
      this.labels = response.data.map(a => {
        return a.index
      })
      this.volume = response.data.map(a => {
        return a['pri.store.size']
      })
      const toint = this.volume.map(x => x * 1) // แปลง arry string ไปเป็น arry number
      function tallyVotes (votes) {
        return votes.reduce((total, vote) => total + vote, 0)
      }
      let byte = tallyVotes(toint)
      this.useGB = (byte / 1024 / 1024 / 1024).toFixed(2) // ใช้ไปกี่ GB แล้ว
      this.output = 2 - this.useGB
      if (this.output <= 0) {
        this.tcca = false
        this.output = 'Out of storage'
      } else {
        this.output = this.output + ' GB'
      }
    },
    async numOfType () {
      this.message = 'Number of Device Type'
      let response = await axios.post(apiUrl + '/api/query/dataVolume', {
        instance: this.user_inst,
        index: this.user_index
      })
      this.output = response.data.length
    },
    async estRetention () {
      this.$refs.options.showLoading({
        color: '#4ea397',
        maskColor: 'transparent',
        textColor: '#ccc'
      })
      let retention = await axios.post(apiUrl + '/api/query/retention', {
        username: this.username
      })
      let days
      if (retention.data > 90) {
        days = 90
      } else {
        days = retention.data
      }

      this.$refs.options.hideLoading()
      let gaugeData = []
      let gaugeObj = {}
      gaugeObj['value'] = days
      gaugeObj['name'] = ''
      gaugeData.push(gaugeObj)
      this.options = {
        title: {
          show: true,
          text: this.chartName,
          textStyle: {
            color: '#ccc',
            fontFamily: 'Avenir, Helvetica, Arial, sans-serif'
          }
        },
        tooltip: {
          formatter: '{a} <br/>{b} : {c} Days'
        },
        // toolbox: {
        //   feature: {
        //     saveAsImage: {
        //       title: 'save as image'
        //     }
        //   }
        // },
        series: [{
          name: 'Date Usage',
          type: 'gauge',
          center: ['50%', '65%'],
          startAngle: 180,
          endAngle: 0,
          min: 0,
          max: 90,
          radius: '85%',
          splitLine: {
            show: false
          },
          axisLine: {
            lineStyle: {
              color: [
                [
                  1, new echarts.graphic.LinearGradient(
                    0, 0, 1, 0, [{
                        offset: 0,
                        color: '#5c53de'
                      },
                      {
                        offset: 1,
                        color: '#18c8ff'
                      }
                    ]
                  )
                ],
                [
                  1, '#413e54'
                ]
              ],
              width: 20,
              opacity: 1
            }
          },
          axisTick: {
            show: false
          },
          detail: {
            formatter: `\n{value}\nDays`,
            textStyle: {
              color: 'white',
              fontFamily: 'Avenir, Helvetica, Arial, sans-serif',
              fontSize: 22
            }
          },
          data: gaugeData,
          axisLabel: {
            show: false
          },
          title: {
            textStyle: {
              color: '#ccc'
            }
          },
          itemStyle: {
            color: 'auto'
          }
        }]
      }
    },
    deleteChart () {
      this.$emit('deleteChart', this.chartId)
    }
  },
  watch: {
    user_index: {
      handler: function (user_index) {
        if (this.user_index) {
          this.options = {}
          this.initChart()
        }
      }
    },
    index_now: {
      handler: function (user_index) {
        if (this.index_now) {
          this.user_index = this.index_now
        }
      }
    }
    // reloadchart: {
    //   handler: function (val) {
    //     this.options = {}
    //     this.initChart()
    //   }
    // }
  }

}
</script>
<style scoped>
/* .chart {
    min-height: 200px
} */
</style>



// WEBPACK FOOTER //
// src/components/x-single.vue